module.exports = __webpack_public_path__ + "media/images/icons/filled/file-text-383c5e1e9ca3a24e06d7a67576a6e358.svg";